import React, { Component } from "react"
import Grid from "@material-ui/core/Grid"
import { Link } from "gatsby"

import SocialMediaLinks, { FooterLinkLists } from "./constants.js"

import "./style.css"

export default class Footer extends Component {
  state = {
    emailInput: "",
    messageElement: (
      <div className="newsletter-success">
        Thank you for signing up for our newsletter!
      </div>
    ),
    messageIn: false,
  }

  handleEmailChange = event => {
    const email = event.target.value ? event.target.value : null

    this.setState({
      emailInput: email,
      messageIn: false,
    })
  }

  removeMessage = () => {
    setTimeout(() => {
      const { messageIn } = this.state

      if (messageIn) {
        this.setState({
          messageIn: false,
        })
      }
    }, 3000)
  }

  get userIsLoggedIn() {
    const { footerUserInfo } = this.props

    return footerUserInfo && footerUserInfo.userId != null
  }

  render() {
    const { typeOfFooter } = this.props

    let footerLinks

    if (this.props.typeOfFooter === "clinicians") {
      footerLinks = FooterLinkLists.clinicians
    } else {
      footerLinks = FooterLinkLists.clinicians
    }

    return (
      <div>
        {typeOfFooter === "newFooter" && (
          <footer id="new-funnel-footer">
            <Grid container justify="flex-end">
              <Grid item md={8} xs={12}>
                <Grid container className="footer-link-container">
                  {footerLinks.map((column, index) => (
                    <Grid key={index} item md={3} xs={12}>
                      <p className="footer-link-column-title">{column.title}</p>
                      {column.links.map(link => {
                        if (link.requiresSignIn) {
                          if (!this.userIsLoggedIn) {
                            return null
                          }
                        }
                        return (
                          <Link
                            key={link.key}
                            className="footer-link-green"
                            to={link.url}
                          >
                            {link.name}
                          </Link>
                        )
                      })}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <p className="footer-address">
                  7801 E 88TH ST
                  <br />
                  INDIANAPOLIS, IN 46256
                  <br />
                  888.926.2727 OR 317.926.2996
                </p>
              </Grid>
              <Grid item xs={11} md={4}>
                <div className="footer-email-column">
                  <div className="footer-media-column-title">
                    <div className="social-media-icon-container">
                      {SocialMediaLinks.map((smLink, index) => (
                        <a
                          key={index}
                          className="social-media-icon-wrapper"
                          href={smLink.url}
                          target="_blank"
                        >
                          <img
                            className="social-media-icon"
                            src={smLink.src}
                            alt={smLink.alt}
                          />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </footer>
        )}
      </div>
    )
  }
}
